import {initElements} from "../define/shared";

export default function initPostList() {
    initElements(".wa-post-list", list => {
        const posts = list.querySelectorAll(".post");

        posts.forEach(post => {
            post.querySelector(".header").addEventListener("click", () => {
                document.querySelectorAll(".word-anchors .word").forEach(word => word.classList.remove("is--active"));
                if (!post.classList.contains("is--open")) {
                    if (list.hasAttribute("data-action-counter")) {
                        fetch(window.RES.base + "wa-theme/v1/word-counter", {
                            method: "POST",
                            headers: {
                                "Content-type": "application/json",
                                "X-WP-Nonce": window.RES.nonce_wp,
                            },
                            body: JSON.stringify({
                                id: post.dataset.postId,
                                nonce: window.RES.nonce
                            })
                        })
                            .then(response => response.json())
                            .then(data => {
                                console.log(data);
                            });
                    }
                    post.classList.add("is--open");
                } else {
                    post.classList.remove("is--open");
                }
            });
        });
    });
}
